import axios from 'axios'

const forceVerifyEmailForNewUserFromFacebook = async (firebaseJWT) => {
  await axios.post('/ali/force-verify-email-for-facebook-user', { firebaseJWT })
}

export default forceVerifyEmailForNewUserFromFacebook
